import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="p-8 max-w-3xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-6">Last updated: April 15, 2025</p>

      <p className="mb-4">
        This Privacy Policy describes how Aimesoft Co., Ltd. ("we", "our", or "us") collects, uses, and protects
        your personal information when you access or use our product, <strong>AimeOpt</strong>, a smart optimization platform.
        By using AimeOpt, you agree to the collection and use of information in accordance with this policy.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">1. Information We Collect</h2>

      <p className="mb-2"><strong>1.1 Personal Information:</strong></p>
      <p className="mb-4">
        When you register or interact with AimeOpt, we may collect information that can be used to identify you,
        such as your full name, email address, phone number, job title, company name, and billing information.
      </p>

      <p className="mb-2"><strong>1.2 Usage Data:</strong></p>
      <p className="mb-4">
        We automatically collect certain technical data when you access our services. This may include:
        IP address, browser type and version, device type, operating system, referral source, and
        data on the pages or features you use, time spent on pages, and other diagnostic data.
      </p>

      <p className="mb-2"><strong>1.3 Cookies and Tracking Technologies:</strong></p>
      <p className="mb-4">
        We use cookies and similar tracking technologies to improve user experience, remember your preferences,
        and analyze how users interact with AimeOpt. You can configure your browser to refuse cookies or notify you when a cookie is being sent.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>

      <p className="mb-2"><strong>2.1 Service Operation:</strong></p>
      <p className="mb-4">
        We use your information to operate, maintain, and improve AimeOpt, including authentication, user support,
        system monitoring, and delivering requested features.
      </p>

      <p className="mb-2"><strong>2.2 Communication:</strong></p>
      <p className="mb-4">
        We may use your email to send system notifications, updates, and service-related information. Marketing emails will only be sent with your consent.
      </p>

      <p className="mb-2"><strong>2.3 Legal Compliance:</strong></p>
      <p className="mb-4">
        We may access, preserve, and disclose your information if required to do so by law or in a good faith belief
        that such action is necessary to (a) comply with legal obligations, (b) enforce our Terms of Service,
        (c) protect the rights or safety of users or the public.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">3. Data Security</h2>
      <p className="mb-4">
        We implement appropriate technical and organizational measures to protect your personal data
        from unauthorized access, use, or disclosure. However, no internet transmission or storage system is 100% secure.
        If a data breach occurs, we will notify you as required by applicable law.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Data Retention</h2>
      <p className="mb-4">
        We retain your personal data for as long as necessary to fulfill the purposes outlined in this policy,
        unless a longer retention period is required by law. You may request deletion of your data at any time.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Your Rights</h2>
      <p className="mb-4">
        Depending on your location, you may have the right to access, correct, delete, or restrict processing of
        your personal data. You may also object to certain uses and withdraw consent at any time.
        To exercise your rights, please contact us using the information below.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. Third-Party Services</h2>
      <p className="mb-4">
        AimeOpt may integrate with third-party services such as analytics tools, payment processors, or communication platforms.
        These services have their own privacy policies, and we encourage you to review them.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. Changes to This Privacy Policy</h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time to reflect changes in our practices or legal obligations.
        When we do, we will revise the "Last updated" date. We encourage you to review this page periodically.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">8. Contact Us</h2>
      <p className="mb-1">If you have any questions, concerns, or requests regarding this Privacy Policy or your personal data, please contact us at:</p>
      <p className="mb-1"><strong>Email:</strong> <a href="mailto:contact@aimesoft.com" className="text-blue-500">contact@aimesoft.com</a></p>
      <p><strong>Website:</strong> <a href="https://aimesoft.com" className="text-blue-500" target="_blank" rel="noreferrer">https://aimesoft.com</a></p>
    </div>
  );
};

export default PrivacyPolicy;
